module.exports = __webpack_public_path__ + "static/media/iosQR.c2c78eea.png";